import { c as _c } from "react/compiler-runtime";
import ButtonLink from '@/components/ButtonLink';
import { useTranslations } from 'next-intl';
import analytics, { type DonateButtonFunELocation } from 'product-analytics';
import { type ReactNode, useCallback } from 'react';
function DonateButton(t0) {
  const $ = _c(11);
  const {
    id,
    children,
    donationFormUrl,
    fundraisingEventId,
    buttonLocation
  } = t0;
  let t1;
  if ($[0] !== buttonLocation || $[1] !== fundraisingEventId) {
    t1 = () => {
      analytics.donationButtonClicked({
        id: fundraisingEventId,
        receiver_type: "FundraisingEvent",
        button_location: buttonLocation
      });
    };
    $[0] = buttonLocation;
    $[1] = fundraisingEventId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const trackDonationButtonClicked = t1;
  const t = useTranslations("nextjs");
  let t2;
  if ($[3] !== t) {
    t2 = t("core.donate_button");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== donationFormUrl || $[7] !== id || $[8] !== t2 || $[9] !== trackDonationButtonClicked) {
    t3 = <ButtonLink id={id} href={donationFormUrl} fullWidth="mobile-only" onClick={trackDonationButtonClicked}>{t2}{children}</ButtonLink>;
    $[5] = children;
    $[6] = donationFormUrl;
    $[7] = id;
    $[8] = t2;
    $[9] = trackDonationButtonClicked;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export default DonateButton;